import LinkIndex from '../components/Link/Index'
import LinkCreate from '../components/Link/Create'

export default [
  {
    path: '/client/links',
    name: 'link-index',
    component: LinkIndex,
    meta: {
      sideMenuId: 'link',
    },
  },
  {
    path: '/client/links/create/:id',
    name: 'link-create',
    component: LinkCreate,
    meta: {
      sideMenuId: 'link-create',
    },
  },
]
